const COLORS = ['red', 'yellow', 'green', 'orange', 'blue', 'purple'];

let nextId = 1;

function randomColor() {
  return COLORS[Math.floor(Math.random() * COLORS.length)];
}

function makeCandy(color, row, col, opts = {}) {
  return {
    id: nextId++,
    color,
    row,
    col,
    fromRow: opts.fromRow != null ? opts.fromRow : row,
    spawning: Boolean(opts.spawning),
  };
}

function cloneGrid(grid) {
  return grid.map((row) => row.map((c) => (c ? { ...c } : null)));
}

export function findMatches(grid, size) {
  const matched = new Set();
  for (let r = 0; r < size; r++) {
    let run = 1;
    for (let c = 1; c <= size; c++) {
      const prev = grid[r][c - 1];
      const cur = c < size ? grid[r][c] : null;
      if (prev && cur && prev.color === cur.color) {
        run += 1;
      } else {
        if (run >= 3 && prev) {
          for (let k = 0; k < run; k++) matched.add(`${r},${c - 1 - k}`);
        }
        run = 1;
      }
    }
  }
  for (let c = 0; c < size; c++) {
    let run = 1;
    for (let r = 1; r <= size; r++) {
      const prev = grid[r - 1][c];
      const cur = r < size ? grid[r][c] : null;
      if (prev && cur && prev.color === cur.color) {
        run += 1;
      } else {
        if (run >= 3 && prev) {
          for (let k = 0; k < run; k++) matched.add(`${r - 1 - k},${c}`);
        }
        run = 1;
      }
    }
  }
  return matched;
}

export function removeMatches(grid, matched) {
  const next = cloneGrid(grid);
  let crushed = 0;
  matched.forEach((key) => {
    const [r, c] = key.split(',').map(Number);
    if (next[r][c]) {
      next[r][c] = null;
      crushed += 1;
    }
  });
  return { grid: next, crushed };
}

/** Drop candies down; new ones spawn above the board (fromRow negative). */
export function collapseWithMotion(grid, size) {
  const next = Array.from({ length: size }, () => Array(size).fill(null));
  for (let c = 0; c < size; c++) {
    const survivors = [];
    for (let r = size - 1; r >= 0; r--) {
      if (grid[r][c]) survivors.push(grid[r][c]);
    }
    let write = size - 1;
    for (const candy of survivors) {
      next[write][c] = {
        ...candy,
        fromRow: candy.row,
        row: write,
        col: c,
        spawning: false,
      };
      write -= 1;
    }
    let spawnOffset = 1;
    while (write >= 0) {
      next[write][c] = makeCandy(randomColor(), write, c, {
        fromRow: -spawnOffset,
        spawning: true,
      });
      spawnOffset += 1;
      write -= 1;
    }
  }
  return next;
}

export function clearMotionFlags(grid) {
  return grid.map((row) =>
    row.map((c) => (c ? { ...c, fromRow: c.row, spawning: false } : null))
  );
}

function resolveInstant(grid, size, scoring) {
  let g = cloneGrid(grid);
  let gained = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const matched = findMatches(g, size);
    if (matched.size === 0) break;
    const removed = removeMatches(g, matched);
    if (scoring) gained += removed.crushed;
    g = clearMotionFlags(collapseWithMotion(removed.grid, size));
  }
  return { grid: g, gained };
}

export function createBoard(size = 8) {
  nextId = 1;
  const grid = Array.from({ length: size }, (_, r) =>
    Array.from({ length: size }, (_, c) => makeCandy(randomColor(), r, c))
  );
  const resolved = resolveInstant(grid, size, false);
  return { grid: clearMotionFlags(resolved.grid), score: 0, size };
}

/** Validate swap; returns swapped grid or null. */
export function swapCandies(state, r1, c1, r2, c2) {
  const { size } = state;
  if (
    r1 < 0 ||
    c1 < 0 ||
    r2 < 0 ||
    c2 < 0 ||
    r1 >= size ||
    c1 >= size ||
    r2 >= size ||
    c2 >= size
  ) {
    return null;
  }
  if (Math.abs(r1 - r2) + Math.abs(c1 - c2) !== 1) return null;

  const grid = cloneGrid(state.grid);
  const a = grid[r1][c1];
  const b = grid[r2][c2];
  if (!a || !b) return null;

  grid[r1][c1] = { ...b, row: r1, col: c1, fromRow: r1, spawning: false };
  grid[r2][c2] = { ...a, row: r2, col: c2, fromRow: r2, spawning: false };

  if (findMatches(grid, size).size === 0) return null;
  return grid;
}

export function candySrc(color) {
  return `/candy_crush/${color}-candy.png`;
}

export { COLORS };
